<app-state-view class="results-listing" [state]="state">
  <loading-state>
    <app-dots-spinner aria-label="Loading..."></app-dots-spinner>
  </loading-state>
  <empty-state>
    <div class="results-listing__placeholder">
      <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
      <div class="results-listing__placeholder-message">Please enter a search query to perform a search.</div>
    </div>
  </empty-state>
  <error-state>
    <div class="results-listing__placeholder results-listing__placeholder--error">
      <mat-icon class="results-listing__placeholder-icon">warning</mat-icon>
      <div class="results-listing__placeholder-message">
        {{ errorMessage || 'An error occurred performing the search. Please try again later.' }}
      </div>
    </div>
  </error-state>
  <content-state>
    <div class="results-listing__container">
      <div class="results-listing__filter-bar">
        <button #fboPopoverAnchor="satPopoverAnchor" type="button" class="results-listing__filter"
                [satPopoverAnchorFor]="fboFiltersPopover" (click)="fboFiltersPopover.toggle()"
                [class.results-listing__filter--active]="fboPopoverAnchor.isPopoverOpen()">
          FBO Filters
          <mat-icon class="results-listing__filter-arrow">keyboard_arrow_down</mat-icon>
        </button>
      </div>
      <div #fboListEl *ngIf="fbos && fbos.length > 0; else placeholder" class="results-listing__list">
        <a class="fbo-card"
           #fboEl *ngFor="let fbo of fbos"
           [class.fbo-card--active]="fbo === activeFbo"
           [routerLink]="['/business', fbo.businessId]"
           (click)="onFboSelected()"
           (mouseenter)="onFboHover(fbo, true)"
           (mouseleave)="onFboHover(fbo, false)">
          <div class="fbo-card__type-row">
            <span class="fbo-card__type">{{ fbo.fuelTypes && fbo.fuelTypes.length ? fbo.fuelTypes.join(' · ') : 'FBO' }}</span>
            <span class="fbo-card__flag" *ngIf="fbo.selfServeFuel">Self-serve fuel</span>
          </div>
          <div class="fbo-card__main">
            <div class="fbo-card__content">
              <h2 class="fbo-card__name">{{ fbo.name }}</h2>
              <div class="fbo-card__body">
                <div class="fbo-card__text" *ngIf="fbo.airportName || fbo.airportIdent">
                  <ng-container *ngIf="fbo.airportName">{{ fbo.airportName }}</ng-container><ng-container *ngIf="fbo.airportName && fbo.airportIdent"> - </ng-container><ng-container *ngIf="fbo.airportIdent">({{ fbo.airportIdent }})</ng-container>
                </div>
                <div class="fbo-card__text" *ngIf="fbo.city || fbo.stateProvince">
                  {{ fbo.city }}<ng-container *ngIf="fbo.city && fbo.stateProvince">, </ng-container>{{ fbo.stateProvince }}
                </div>
              </div>
            </div>
            <div class="fbo-card__photo" *ngIf="fbo.thumbnailPhotoPath">
              <img class="fbo-card__image" [src]="fbo.thumbnailPhotoPath" alt="" />
            </div>
          </div>
        </a>
      </div>
      <mat-paginator
        *ngIf="fbos && fbos.length > 0"
        class="results-listing__pagination"
        [pageIndex]="pageIndex"
        [length]="totalFbos"
        [pageSize]="pageSize"
        (page)="onPageChanged($event)">
      </mat-paginator>
    </div>
  </content-state>
</app-state-view>

<ng-template #placeholder>
  <div class="results-listing__placeholder">
    <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
    <div class="results-listing__placeholder-message">
      No results found matching your search criteria. Try reducing the number of filters used in the search.
    </div>
  </div>
</ng-template>


<sat-popover #fboFiltersPopover horizontalAlign="start" verticalAlign="below" hasBackdrop>
  <div class="results-listing__popover">
    <app-fbo-finder-filter-list #fboFilters [query]="query" [compact]="true"
                                (filtersChange)="onFiltersChanged()">
    </app-fbo-finder-filter-list>
  </div>
</sat-popover>
